import React, { useEffect, useState, useRef } from "react";
import setInputValue from "../hooks/useInputValue";
import "../assets/styles/components/HorizontalFormContact.sass";

const HorizontalFormContact = () => {
  const formButton = document.getElementById("horizontal-form__button");
  const formInputs = document.getElementById("horizontal-form");
  let name = setInputValue("");
  let email = setInputValue("");
  let phone = setInputValue("");
  let message = setInputValue("");

  // Anti-bot protections
  const formLoadTime = useRef(Date.now());
  const [hasInteracted, setHasInteracted] = useState(false);
  const website = setInputValue(""); // Honeypot

  // Detect human interaction
  useEffect(() => {
    const handleInteraction = () => setHasInteracted(true);

    window.addEventListener('mousemove', handleInteraction, { once: true });
    window.addEventListener('keydown', handleInteraction, { once: true });
    window.addEventListener('touchstart', handleInteraction, { once: true });

    return () => {
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  // Rate limiting
  const checkRateLimit = () => {
    try {
      const submissions = JSON.parse(localStorage.getItem('formSubmissionsHorizontal') || '[]');
      const now = Date.now();
      const oneHour = 60 * 60 * 1000;

      // Filter submissions from the last hour
      const recentSubmissions = submissions.filter(time => now - time < oneHour);

      if (recentSubmissions.length >= 3) {
        return false; // Blocked
      }

      // Add current submission
      recentSubmissions.push(now);
      localStorage.setItem('formSubmissionsHorizontal', JSON.stringify(recentSubmissions));
      return true;
    } catch (error) {
      return true; // If localStorage fails, allow
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    // Anti-bot validations
    // 1. Honeypot - if filled, it's a bot
    if (website.value !== "") {
      gracias(); // Show success but DON'T send
      return;
    }

    // 2. Minimum time - bots fill forms instantly
    const timeSinceLoad = (Date.now() - formLoadTime.current) / 1000;
    if (timeSinceLoad < 3) {
      gracias(); // Show success but DON'T send
      return;
    }

    // 3. Interaction - bots don't move the mouse
    if (!hasInteracted) {
      gracias(); // Show success but DON'T send
      return;
    }

    // 4. Rate limiting - maximum 3 submissions per hour
    if (!checkRateLimit()) {
      formButton.innerHTML = "DEMASIADOS INTENTOS";
      formButton.classList.add("btn-fill");
      validate();
      return;
    }

    if (name.value === "" || email.value === "") {
      formButton.innerHTML = "INGRESE INFORMACIÓN";

      const inputs = formInputs.elements;

      if (name.value === "") inputs["Nombre"].classList.add("btn-fill");
      if (email.value === "") inputs["Correo"].classList.add("btn-fill");
      formButton.classList.add("btn-fill");
      validate();
    } else {
      sendForm();
    }
  };

  const sendForm = () => {
    const formData = new FormData();
    formData.append("name", name.value);
    formData.append("email", email.value);
    formData.append("phone", phone.value);
    formData.append("mensaje", message.value);
    formData.append("languaje", "es");
    formData.append("section", "contactHome-series");

    fetch(`https://legendofeldorado.com/2018/api/send-contact`, {
      method: "POST",
      body: formData,
    });

    const dataEmail = {
      name: name.value,
      email: email.value,
      section: "contactHome-series",
    };

    fetch(`${process.env.REACT_APP_SEND_EMAIL_HORIZONTAL}/horizontal-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataEmail),
    }).catch((error) => {
      console.log(error);
    });

    gracias();
  };

  const gracias = () => {
    formButton.innerHTML = "GRACIAS";
    formButton.classList.add("btn-thanks");
    resetForm();
  };

  const resetForm = () => {
    setTimeout(() => {
      const inputs = formInputs.elements;

      formButton.innerHTML = "CONTÁCTAME";
      formButton.classList.remove("btn-thanks");
      formButton.classList.remove("btn-fill");
      inputs["Nombre"].classList.remove("btn-fill");
      inputs["Correo"].classList.remove("btn-fill");
      inputs["Telefono"].classList.remove("btn-fill");
      inputs["Nombre"].value = "";
      inputs["Correo"].value = "";
      inputs["Telefono"].value = "";
      name.value = "";
      email.value = "";
      phone.value = "";
      message.value = "";
    }, 3000);
  };

  const validate = () => {
    setTimeout(() => {
      const inputs = formInputs.elements;

      formButton.innerHTML = "CONTÁCTAME";
      formButton.classList.remove("btn-fill");
      inputs["Nombre"].classList.remove("btn-fill");
      inputs["Correo"].classList.remove("btn-fill");
      inputs["Telefono"].classList.remove("btn-fill");
    }, 3000);
  };

  return (
    <>
      <div className="row">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form id="horizontal-form" className="horizontal-form" onSubmit={(e) => handleOnSubmit(e)}>
                <input type="text" name="Nombre" placeholder="Nombre" {...name} />
                <input type="email" name="Correo" placeholder="Correo" {...email} />
                <input type="text" name="Telefono" placeholder="Teléfono (Opcional)" {...phone} />

                {/* Honeypot - Invisible for humans */}
                <input
                  type="text"
                  name="website"
                  placeholder="Website"
                  {...website}
                  style={{
                    position: 'absolute',
                    left: '-9999px',
                    width: '1px',
                    height: '1px'
                  }}
                  tabIndex="-1"
                  autoComplete="off"
                />

                <input type="hidden" value="Español" />
                <button id="horizontal-form__button" type="submit">
                  CONTÁCTAME
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HorizontalFormContact;
